/* contact-onne.js — ONNE "Contact Us" support agent (estilo Hawkers, 2 niveles).
   Custom element <contact-onne>. Wizard:
     Q1: ¿Tu consulta es sobre un pedido?  → rama "Sobre mi pedido" | "Otra consulta"
     Q2: select de casuísticas por rama → DEFLEXIÓN (link) | FORMULARIO (acción/escala).
   Habla con el backend del sales-agent: POST {endpoint}/api/support/contact.
   Reglas duras:
     - NUNCA afirma un reembolso ni un éxito que no ocurrió (el ack viene del server).
     - Cambio de dirección (A5): verificación D-11 (nº pedido + email/últimos 4 tel).
     - Honeypot oculto `hp` SIEMPRE en cada POST (anti-spam).
     - Consentimiento privacidad obligatorio antes de enviar.
     - Gateado por SUPPORT_CONTACT_ENABLED → 503 {disabled} → estado "muy pronto".
   Horizon-ONNE conventions (handbook 09): custom element, connectedCallback, sin IIFE.
   Reutiliza el design system de support-hub-onne.css (clases support-onne__* / order-status-onne__*). */

const CCOPY = {
  es: {
    title: 'Atención al cliente',
    subtitle: 'Cuéntanos en qué podemos ayudarte y lo resolvemos contigo 🤍',
    q1_title: '¿Tu consulta es sobre un pedido?',
    q1_yes: 'Sí, es sobre mi pedido',
    q1_no: 'No, es otra consulta',
    branch_order_title: 'Sobre mi pedido',
    branch_other_title: 'Otra consulta',
    select_ph: 'Selecciona tu consulta',
    cta_continue: 'Continuar',
    back: 'Volver',
    loading: 'Un momento…',
    // --- topics: SOBRE MI PEDIDO
    a_where: '¿Dónde está mi pedido?',
    a_return: 'Quiero devolver o cambiar / producto defectuoso',
    a_address: 'Cambiar la dirección de envío',
    a_missing: 'Falta un producto o recibí uno incorrecto',
    a_refund: 'Estado de mi reembolso',
    // --- topics: OTRA CONSULTA
    b_product: 'Información de un producto (tallas, stock, material)',
    b_discount: 'Mi código de descuento no funciona',
    b_payment: 'Problema con un pago',
    b_account: 'Problema con mi cuenta',
    b_policy: 'Información sobre cambios y devoluciones (política)',
    b_collab: 'Colaboraciones / prensa / trabajo',
    b_other: 'Otra consulta',
    // --- deflections
    defl_where_title: 'Mira dónde está tu pedido',
    defl_where_body: 'Puedes ver el estado y el seguimiento de tu pedido al instante en nuestro buscador 🌊',
    defl_where_cta: 'Ver estado de mi pedido',
    defl_return_title: 'Devoluciones y cambios',
    defl_return_body: 'Tramita tu devolución o cambio (y los productos defectuosos) en unos pasos desde aquí 🤍',
    defl_return_cta: 'Ir a devoluciones',
    defl_policy_title: 'Política de cambios y devoluciones',
    defl_policy_cta: 'Ver condiciones completas',
    policy: [
      'Tienes 14 días naturales desde que recibes tu pedido para solicitar la devolución.',
      'El producto vuelve sin usar, en perfecto estado, con etiquetas, precinto y embalaje original.',
      'El reembolso se gestiona SIEMPRE tras recibir e inspeccionar el producto en nuestras oficinas de Elda (normalmente en ~72h desde que llega). Nunca antes.',
      'Si eliges cambio o crédito de tienda, la devolución es gratis. Si eliges la devolución del dinero, el coste de la etiqueta se descuenta de tu reembolso. Si el motivo es nuestro (defectuoso o incorrecto), es gratis. Mensajería con seguimiento.',
      'Aceptamos cambios por otro producto, además de crédito de tienda o la devolución del dinero. Eliges la opción al tramitar tu devolución.',
      'Producto defectuoso: cubierto por la garantía legal de 3 años; lo revisa nuestro equipo de Calidad.',
    ],
    policy_titles: ['Plazo', 'Estado del producto', 'Reembolso', 'Envío de la devolución', 'Cambios', 'Defectuoso y garantía'],
    // --- forms: labels
    f_name: 'Nombre', f_name_ph: 'Tu nombre',
    f_email: 'Email', f_email_ph: 'tu@email.com',
    f_message: 'Cuéntanos un poco más', f_message_ph: 'Escribe aquí los detalles…',
    f_order: 'Número de pedido', f_order_ph: 'Empieza por ONNE o por #',
    f_factor: 'Email o últimos 4 del teléfono', f_factor_help: 'El que usaste en la compra', f_factor_ph: 'tu@email.com',
    f_product_query: '¿Qué producto te interesa?', f_product_query_ph: 'Nombre del modelo, talla o color…',
    f_discount_code: 'Código de descuento', f_discount_code_ph: 'Ej. VERANO10',
    // --- address fields
    addr_title: 'Nueva dirección de envío',
    addr_intro: 'Solo podemos cambiarla si tu pedido aún no ha salido de nuestro almacén. Primero verificamos que el pedido es tuyo 🤍',
    a_address1: 'Calle y número', a_address1_ph: 'Calle Poeta Zorrilla, 44',
    a_address2: 'Piso / puerta (opcional)', a_address2_ph: '3º B',
    a_city: 'Ciudad', a_city_ph: 'Elda',
    a_zip: 'Código postal', a_zip_ph: '03600',
    a_province: 'Provincia', a_province_ph: 'Alicante',
    a_country: 'País', a_country_ph: 'España',
    a_phone: 'Teléfono (opcional)', a_phone_ph: '600 000 000',
    a_first_name: 'Nombre del destinatario', a_last_name: 'Apellidos del destinatario',
    // --- consent + CTAs
    consent: 'He leído y acepto la <a href="{url}" target="_blank" rel="noopener">política de privacidad y las condiciones</a>.',
    cta_send: 'Enviar',
    cta_send_address: 'Cambiar la dirección',
    cta_check_discount: 'Comprobar el código',
    cta_check_product: 'Ver disponibilidad',
    // --- validation
    need_name: 'Dinos tu nombre 🤍',
    need_email: 'Necesitamos un email válido 🤍',
    need_message: 'Cuéntanos un poco más para poder ayudarte 🤍',
    need_order: 'Indícanos tu número de pedido 🤍',
    need_factor: 'Añade el email o los últimos 4 del teléfono 🤍',
    need_product_query: 'Dinos qué producto te interesa 🤍',
    need_discount_code: 'Escribe tu código de descuento 🤍',
    need_address: 'Completa la dirección de envío 🤍',
    need_consent: 'Marca la casilla para aceptar la política de privacidad 🤍',
    // --- responses
    discount_valid: 'Tu código {code} está activo 🤍',
    discount_value_pct: 'Descuento del {value}%.',
    discount_value_amount: 'Descuento de {value}.',
    discount_invalid: 'No encontramos un código activo con ese nombre. Revisa que esté bien escrito (a veces se cuela un espacio) 🤍',
    product_sizes: 'Tallas disponibles',
    product_unavailable: 'Ahora mismo sin stock',
    product_material: 'Material',
    product_not_found: 'No hemos podido encontrar ese producto. ¿Nos das el nombre exacto del modelo? Si no, te paso con el equipo 🤍',
    product_price_from: 'Desde',
    product_color: 'Color',
    product_size: 'Talla',
    product_view: 'Ver producto en la web',
    product_choose: '¿Cuál de estos es? Elige tu producto 🤍',
    product_not_this: '¿No es este? Escríbenos el nombre exacto del modelo.',
    product_sold_out: 'Agotado',
    address_updated: '¡Listo! Hemos actualizado la dirección de envío de tu pedido {order} 🤍 Te enviamos un email de confirmación a la dirección de la compra.',
    verification_required: 'Para protegerte, primero verificamos que el pedido es tuyo. Indícanos el número de pedido y el email o los últimos 4 dígitos del teléfono de la compra 🤍',
    verification_failed: 'Esos datos no me cuadran con ningún pedido y no quiero tocar un pedido que no sea tuyo. 🤍 {attempts}',
    verification_attempts: 'Te quedan {n} intentos.',
    address_escalated: 'Tu pedido ya está en preparación o de camino, así que no podemos cambiar la dirección desde aquí. Lo pasamos a nuestro equipo para revisarlo contigo 🤍',
    escalated: 'Lo hemos recibido 🤍 Nuestro equipo lo revisa y te escribe a tu email lo antes posible. Gracias por tu paciencia ✨',
    escalated_ref: 'Referencia: {ref}',
    // --- generic states
    talk_team: 'Hablar con el equipo',
    retry: 'Intentar de nuevo',
    service_unavailable: 'Estamos haciendo unos ajustes y esta opción no está disponible ahora mismo. Vuelve en un ratito o escríbenos 🤍',
    network_error: 'Ups, no hemos podido conectar. ¿Probamos otra vez?',
    invalid_email_server: 'Ese email no parece válido. ¿Lo revisamos? 🤍',
  },
  en: {
    title: 'Customer care',
    subtitle: "Tell us how we can help and we'll sort it out together 🤍",
    q1_title: 'Is your query about an order?',
    q1_yes: "Yes, it's about my order",
    q1_no: "No, it's another query",
    branch_order_title: 'About my order',
    branch_other_title: 'Another query',
    select_ph: 'Select your query',
    cta_continue: 'Continue',
    back: 'Back',
    loading: 'One moment…',
    a_where: 'Where is my order?',
    a_return: 'I want to return or exchange / faulty product',
    a_address: 'Change the shipping address',
    a_missing: 'A product is missing or I received the wrong one',
    a_refund: 'My refund status',
    b_product: 'Product information (sizes, stock, material)',
    b_discount: "My discount code isn't working",
    b_payment: 'Problem with a payment',
    b_account: 'Problem with my account',
    b_policy: 'Information about exchanges and returns (policy)',
    b_collab: 'Collaborations / press / work',
    b_other: 'Another query',
    defl_where_title: 'See where your order is',
    defl_where_body: 'You can check your order status and tracking instantly in our lookup 🌊',
    defl_where_cta: 'See my order status',
    defl_return_title: 'Returns and exchanges',
    defl_return_body: 'Start your return or exchange (and faulty products) in a few steps from here 🤍',
    defl_return_cta: 'Go to returns',
    defl_policy_title: 'Exchanges and returns policy',
    defl_policy_cta: 'See full conditions',
    policy: [
      'You have 14 calendar days from when you receive your order to request the return.',
      'The item must come back unused, in perfect condition, with tags, hygiene seal and original packaging.',
      'Refunds are ALWAYS processed after we receive and inspect the item at our Elda offices (usually within ~72h of arrival). Never before.',
      "If you choose an exchange or store credit, the return is free. If you choose a money refund, the return label cost is deducted from your refund. If the reason is ours (faulty or incorrect), it's free. Tracked courier.",
      'We accept exchanges for another product, plus store credit or a money refund. You pick the option when you start your return.',
      'Faulty products: covered by the 3-year legal guarantee; reviewed by our Quality team.',
    ],
    policy_titles: ['Timeframe', 'Product condition', 'Refund', 'Return shipping', 'Exchanges', 'Faulty & warranty'],
    f_name: 'Name', f_name_ph: 'Your name',
    f_email: 'Email', f_email_ph: 'you@email.com',
    f_message: 'Tell us a bit more', f_message_ph: 'Write the details here…',
    f_order: 'Order number', f_order_ph: 'Starts with ONNE or #',
    f_factor: 'Email or last 4 of phone', f_factor_help: 'The one used at checkout', f_factor_ph: 'you@email.com',
    f_product_query: 'Which product are you interested in?', f_product_query_ph: 'Model name, size or colour…',
    f_discount_code: 'Discount code', f_discount_code_ph: 'e.g. SUMMER10',
    addr_title: 'New shipping address',
    addr_intro: "We can only change it if your order hasn't left our warehouse yet. First we verify the order is yours 🤍",
    a_address1: 'Street and number', a_address1_ph: '44 Poeta Zorrilla St.',
    a_address2: 'Flat / unit (optional)', a_address2_ph: '3rd B',
    a_city: 'City', a_city_ph: 'Elda',
    a_zip: 'Postcode', a_zip_ph: '03600',
    a_province: 'Province / State', a_province_ph: 'Alicante',
    a_country: 'Country', a_country_ph: 'Spain',
    a_phone: 'Phone (optional)', a_phone_ph: '600 000 000',
    a_first_name: 'Recipient first name', a_last_name: 'Recipient last name',
    consent: 'I have read and accept the <a href="{url}" target="_blank" rel="noopener">privacy policy and conditions</a>.',
    cta_send: 'Send',
    cta_send_address: 'Change the address',
    cta_check_discount: 'Check the code',
    cta_check_product: 'Check availability',
    need_name: 'Tell us your name 🤍',
    need_email: 'We need a valid email 🤍',
    need_message: 'Tell us a bit more so we can help 🤍',
    need_order: 'Please share your order number 🤍',
    need_factor: 'Add the email or last 4 digits of the phone 🤍',
    need_product_query: 'Tell us which product you mean 🤍',
    need_discount_code: 'Write your discount code 🤍',
    need_address: 'Complete the shipping address 🤍',
    need_consent: 'Tick the box to accept the privacy policy 🤍',
    discount_valid: 'Your code {code} is active 🤍',
    discount_value_pct: '{value}% off.',
    discount_value_amount: '{value} off.',
    discount_invalid: "We couldn't find an active code with that name. Check the spelling (sometimes a space sneaks in) 🤍",
    product_sizes: 'Available sizes',
    product_unavailable: 'Currently out of stock',
    product_material: 'Material',
    product_not_found: "We couldn't find that product. Could you give us the exact model name? Otherwise I'll connect you with the team 🤍",
    product_price_from: 'From',
    product_color: 'Colour',
    product_size: 'Size',
    product_view: 'View product on the site',
    product_choose: 'Which one is it? Pick your product 🤍',
    product_not_this: "Not this one? Send us the exact model name.",
    product_sold_out: 'Sold out',
    address_updated: "Done! We've updated the shipping address for your order {order} 🤍 We're sending a confirmation email to the address used at checkout.",
    verification_required: 'To protect you, first we verify the order is yours. Share the order number and the email or last 4 digits of the phone used at checkout 🤍',
    verification_failed: "Those details don't match any order and I don't want to touch an order that isn't yours. 🤍 {attempts}",
    verification_attempts: 'You have {n} attempts left.',
    address_escalated: "Your order is already being prepared or on its way, so we can't change the address from here. We're passing it to our team to check it with you 🤍",
    escalated: "We've received it 🤍 Our team is reviewing it and will email you as soon as possible. Thanks for your patience ✨",
    escalated_ref: 'Reference: {ref}',
    talk_team: 'Talk to our team',
    retry: 'Try again',
    service_unavailable: "We're making a few tweaks and this isn't available right now. Check back in a bit or write to us 🤍",
    network_error: "Oops, we couldn't connect. Shall we try again?",
    invalid_email_server: "That email doesn't look valid. Shall we check it? 🤍",
  },
  it: {
    title: 'Assistenza clienti',
    subtitle: 'Dicci come possiamo aiutarti e lo risolviamo insieme 🤍',
    q1_title: 'La tua richiesta riguarda un ordine?',
    q1_yes: 'Sì, riguarda il mio ordine',
    q1_no: "No, è un'altra richiesta",
    branch_order_title: 'Sul mio ordine',
    branch_other_title: "Un'altra richiesta",
    select_ph: 'Seleziona la tua richiesta',
    cta_continue: 'Continua',
    back: 'Indietro',
    loading: 'Un attimo…',
    a_where: "Dov'è il mio ordine?",
    a_return: 'Voglio restituire o cambiare / prodotto difettoso',
    a_address: "Cambiare l'indirizzo di spedizione",
    a_missing: 'Manca un prodotto o ne ho ricevuto uno sbagliato',
    a_refund: 'Stato del mio rimborso',
    b_product: 'Informazioni su un prodotto (taglie, stock, materiale)',
    b_discount: 'Il mio codice sconto non funziona',
    b_payment: 'Problema con un pagamento',
    b_account: 'Problema con il mio account',
    b_policy: 'Informazioni su cambi e resi (policy)',
    b_collab: 'Collaborazioni / stampa / lavoro',
    b_other: "Un'altra richiesta",
    defl_where_title: "Guarda dov'è il tuo ordine",
    defl_where_body: 'Puoi vedere stato e tracciamento del tuo ordine subito nel nostro strumento 🌊',
    defl_where_cta: 'Vedi lo stato del mio ordine',
    defl_return_title: 'Resi e cambi',
    defl_return_body: 'Gestisci il reso o il cambio (e i prodotti difettosi) in pochi passi da qui 🤍',
    defl_return_cta: 'Vai ai resi',
    defl_policy_title: 'Policy di cambi e resi',
    defl_policy_cta: 'Vedi le condizioni complete',
    policy: [
      "Hai 14 giorni naturali da quando ricevi il tuo ordine per richiedere il reso.",
      "Il prodotto torna non usato, in perfette condizioni, con etichette, sigillo e imballaggio originale.",
      'Il rimborso si gestisce SEMPRE dopo aver ricevuto e ispezionato il prodotto nei nostri uffici di Elda (di solito entro ~72h dall\'arrivo). Mai prima.',
      "Se scegli un cambio o un credito negozio, il reso è gratuito. Se scegli il rimborso in denaro, il costo dell'etichetta viene detratto dal rimborso. Se il motivo è nostro (difettoso o errato), è gratuito. Corriere tracciato.",
      "Accettiamo cambi con un altro prodotto, oltre al credito negozio o al rimborso in denaro. Scegli l'opzione quando avvii il reso.",
      'Prodotto difettoso: coperto dalla garanzia legale di 3 anni; lo esamina il team Qualità.',
    ],
    policy_titles: ['Tempistica', 'Condizioni del prodotto', 'Rimborso', 'Spedizione del reso', 'Cambi', 'Difettoso e garanzia'],
    f_name: 'Nome', f_name_ph: 'Il tuo nome',
    f_email: 'Email', f_email_ph: 'tu@email.com',
    f_message: 'Raccontaci qualcosa in più', f_message_ph: 'Scrivi qui i dettagli…',
    f_order: "Numero d'ordine", f_order_ph: 'Inizia con ONNE o con #',
    f_factor: 'Email o ultime 4 del telefono', f_factor_help: "Quello usato all'acquisto", f_factor_ph: 'tu@email.com',
    f_product_query: 'Quale prodotto ti interessa?', f_product_query_ph: 'Nome del modello, taglia o colore…',
    f_discount_code: 'Codice sconto', f_discount_code_ph: 'Es. ESTATE10',
    addr_title: 'Nuovo indirizzo di spedizione',
    addr_intro: "Possiamo cambiarlo solo se il tuo ordine non è ancora partito dal magazzino. Prima verifichiamo che l'ordine sia tuo 🤍",
    a_address1: 'Via e numero', a_address1_ph: 'Via Poeta Zorrilla, 44',
    a_address2: 'Piano / interno (opzionale)', a_address2_ph: '3° B',
    a_city: 'Città', a_city_ph: 'Elda',
    a_zip: 'CAP', a_zip_ph: '03600',
    a_province: 'Provincia', a_province_ph: 'Alicante',
    a_country: 'Paese', a_country_ph: 'Spagna',
    a_phone: 'Telefono (opzionale)', a_phone_ph: '600 000 000',
    a_first_name: 'Nome del destinatario', a_last_name: 'Cognome del destinatario',
    consent: 'Ho letto e accetto la <a href="{url}" target="_blank" rel="noopener">privacy policy e le condizioni</a>.',
    cta_send: 'Invia',
    cta_send_address: "Cambia l'indirizzo",
    cta_check_discount: 'Controlla il codice',
    cta_check_product: 'Vedi disponibilità',
    need_name: 'Dicci il tuo nome 🤍',
    need_email: 'Ci serve un email valido 🤍',
    need_message: 'Raccontaci qualcosa in più per aiutarti 🤍',
    need_order: "Indicaci il tuo numero d'ordine 🤍",
    need_factor: 'Aggiungi email o ultime 4 cifre del telefono 🤍',
    need_product_query: 'Dicci quale prodotto intendi 🤍',
    need_discount_code: 'Scrivi il tuo codice sconto 🤍',
    need_address: "Completa l'indirizzo di spedizione 🤍",
    need_consent: 'Spunta la casella per accettare la privacy policy 🤍',
    discount_valid: 'Il tuo codice {code} è attivo 🤍',
    discount_value_pct: 'Sconto del {value}%.',
    discount_value_amount: 'Sconto di {value}.',
    discount_invalid: 'Non troviamo un codice attivo con quel nome. Controlla che sia scritto bene (a volte scappa uno spazio) 🤍',
    product_sizes: 'Taglie disponibili',
    product_unavailable: 'Al momento esaurito',
    product_material: 'Materiale',
    product_not_found: 'Non abbiamo trovato quel prodotto. Ci dai il nome esatto del modello? Altrimenti ti metto in contatto con il team 🤍',
    product_price_from: 'Da',
    product_color: 'Colore',
    product_size: 'Taglia',
    product_view: 'Vedi il prodotto sul sito',
    product_choose: 'Quale di questi è? Scegli il tuo prodotto 🤍',
    product_not_this: 'Non è questo? Scrivici il nome esatto del modello.',
    product_sold_out: 'Esaurito',
    address_updated: "Fatto! Abbiamo aggiornato l'indirizzo di spedizione del tuo ordine {order} 🤍 Ti inviamo un email di conferma all'indirizzo dell'acquisto.",
    verification_required: "Per proteggerti, prima verifichiamo che l'ordine sia tuo. Indicaci il numero d'ordine e l'email o le ultime 4 cifre del telefono dell'acquisto 🤍",
    verification_failed: "Questi dati non corrispondono a nessun ordine e non voglio toccare un ordine che non è tuo. 🤍 {attempts}",
    verification_attempts: 'Ti restano {n} tentativi.',
    address_escalated: "Il tuo ordine è già in preparazione o in viaggio, quindi non possiamo cambiare l'indirizzo da qui. Lo passiamo al team per verificarlo con te 🤍",
    escalated: "L'abbiamo ricevuto 🤍 Il nostro team lo esamina e ti scrive via email il prima possibile. Grazie per la pazienza ✨",
    escalated_ref: 'Riferimento: {ref}',
    talk_team: 'Parla con il team',
    retry: 'Riprova',
    service_unavailable: 'Stiamo facendo alcune modifiche e ora non è disponibile. Torna tra poco o scrivici 🤍',
    network_error: 'Ops, non siamo riusciti a connetterci. Riproviamo?',
    invalid_email_server: 'Questo email non sembra valido. Lo controlliamo? 🤍',
  },
  pt: {
    title: 'Apoio ao cliente',
    subtitle: 'Diz-nos como podemos ajudar e resolvemos contigo 🤍',
    q1_title: 'A tua questão é sobre uma encomenda?',
    q1_yes: 'Sim, é sobre a minha encomenda',
    q1_no: 'Não, é outra questão',
    branch_order_title: 'Sobre a minha encomenda',
    branch_other_title: 'Outra questão',
    select_ph: 'Seleciona a tua questão',
    cta_continue: 'Continuar',
    back: 'Voltar',
    loading: 'Um momento…',
    a_where: 'Onde está a minha encomenda?',
    a_return: 'Quero devolver ou trocar / produto defeituoso',
    a_address: 'Mudar a morada de envio',
    a_missing: 'Falta um produto ou recebi um errado',
    a_refund: 'Estado do meu reembolso',
    b_product: 'Informação de um produto (tamanhos, stock, material)',
    b_discount: 'O meu código de desconto não funciona',
    b_payment: 'Problema com um pagamento',
    b_account: 'Problema com a minha conta',
    b_policy: 'Informação sobre trocas e devoluções (política)',
    b_collab: 'Colaborações / imprensa / trabalho',
    b_other: 'Outra questão',
    defl_where_title: 'Vê onde está a tua encomenda',
    defl_where_body: 'Podes ver o estado e o seguimento da tua encomenda de imediato no nosso localizador 🌊',
    defl_where_cta: 'Ver estado da minha encomenda',
    defl_return_title: 'Devoluções e trocas',
    defl_return_body: 'Trata da tua devolução ou troca (e produtos defeituosos) em poucos passos aqui 🤍',
    defl_return_cta: 'Ir para devoluções',
    defl_policy_title: 'Política de trocas e devoluções',
    defl_policy_cta: 'Ver condições completas',
    policy: [
      'Tens 14 dias naturais desde que recebes a tua encomenda para solicitar a devolução.',
      'O produto volta sem uso, em perfeito estado, com etiquetas, selo e embalagem original.',
      'O reembolso é SEMPRE processado depois de recebermos e inspecionarmos o produto nos nossos escritórios de Elda (normalmente em ~72h desde que chega). Nunca antes.',
      'Se escolheres uma troca ou crédito de loja, a devolução é grátis. Se escolheres o reembolso em dinheiro, o custo da etiqueta é descontado do teu reembolso. Se o motivo for nosso (defeituoso ou incorreto), é grátis. Transportadora com seguimento.',
      'Aceitamos trocas por outro produto, além de crédito de loja ou reembolso em dinheiro. Escolhes a opção ao tratar a tua devolução.',
      'Produto defeituoso: coberto pela garantia legal de 3 anos; analisado pela nossa equipa de Qualidade.',
    ],
    policy_titles: ['Prazo', 'Estado do produto', 'Reembolso', 'Envio da devolução', 'Trocas', 'Defeituoso e garantia'],
    f_name: 'Nome', f_name_ph: 'O teu nome',
    f_email: 'Email', f_email_ph: 'tu@email.com',
    f_message: 'Conta-nos um pouco mais', f_message_ph: 'Escreve aqui os detalhes…',
    f_order: 'Número da encomenda', f_order_ph: 'Começa por ONNE ou por #',
    f_factor: 'Email ou últimos 4 do telemóvel', f_factor_help: 'O que usaste na compra', f_factor_ph: 'tu@email.com',
    f_product_query: 'Que produto te interessa?', f_product_query_ph: 'Nome do modelo, tamanho ou cor…',
    f_discount_code: 'Código de desconto', f_discount_code_ph: 'Ex. VERAO10',
    addr_title: 'Nova morada de envio',
    addr_intro: 'Só podemos mudá-la se a tua encomenda ainda não saiu do armazém. Primeiro verificamos que a encomenda é tua 🤍',
    a_address1: 'Rua e número', a_address1_ph: 'Rua Poeta Zorrilla, 44',
    a_address2: 'Andar / porta (opcional)', a_address2_ph: '3º B',
    a_city: 'Cidade', a_city_ph: 'Elda',
    a_zip: 'Código postal', a_zip_ph: '03600',
    a_province: 'Distrito', a_province_ph: 'Alicante',
    a_country: 'País', a_country_ph: 'Espanha',
    a_phone: 'Telemóvel (opcional)', a_phone_ph: '600 000 000',
    a_first_name: 'Nome do destinatário', a_last_name: 'Apelidos do destinatário',
    consent: 'Li e aceito a <a href="{url}" target="_blank" rel="noopener">política de privacidade e as condições</a>.',
    cta_send: 'Enviar',
    cta_send_address: 'Mudar a morada',
    cta_check_discount: 'Verificar o código',
    cta_check_product: 'Ver disponibilidade',
    need_name: 'Diz-nos o teu nome 🤍',
    need_email: 'Precisamos de um email válido 🤍',
    need_message: 'Conta-nos um pouco mais para te ajudarmos 🤍',
    need_order: 'Indica o teu número de encomenda 🤍',
    need_factor: 'Adiciona o email ou os últimos 4 dígitos do telemóvel 🤍',
    need_product_query: 'Diz-nos que produto queres 🤍',
    need_discount_code: 'Escreve o teu código de desconto 🤍',
    need_address: 'Completa a morada de envio 🤍',
    need_consent: 'Marca a caixa para aceitar a política de privacidade 🤍',
    discount_valid: 'O teu código {code} está ativo 🤍',
    discount_value_pct: 'Desconto de {value}%.',
    discount_value_amount: 'Desconto de {value}.',
    discount_invalid: 'Não encontramos um código ativo com esse nome. Verifica se está bem escrito (às vezes escapa um espaço) 🤍',
    product_sizes: 'Tamanhos disponíveis',
    product_unavailable: 'De momento sem stock',
    product_material: 'Material',
    product_not_found: 'Não conseguimos encontrar esse produto. Dás-nos o nome exato do modelo? Senão, ponho-te em contacto com a equipa 🤍',
    product_price_from: 'Desde',
    product_color: 'Cor',
    product_size: 'Tamanho',
    product_view: 'Ver produto no site',
    product_choose: 'Qual destes é? Escolhe o teu produto 🤍',
    product_not_this: 'Não é este? Escreve-nos o nome exato do modelo.',
    product_sold_out: 'Esgotado',
    address_updated: 'Pronto! Atualizámos a morada de envio da tua encomenda {order} 🤍 Enviamos um email de confirmação para a morada da compra.',
    verification_required: 'Para te proteger, primeiro verificamos que a encomenda é tua. Indica o número da encomenda e o email ou os últimos 4 dígitos do telemóvel da compra 🤍',
    verification_failed: 'Esses dados não correspondem a nenhuma encomenda e não quero mexer numa encomenda que não seja tua. 🤍 {attempts}',
    verification_attempts: 'Restam-te {n} tentativas.',
    address_escalated: 'A tua encomenda já está em preparação ou a caminho, por isso não podemos mudar a morada por aqui. Passamos à equipa para verificar contigo 🤍',
    escalated: 'Recebemos 🤍 A nossa equipa analisa e escreve-te para o teu email assim que possível. Obrigada pela paciência ✨',
    escalated_ref: 'Referência: {ref}',
    talk_team: 'Falar com a equipa',
    retry: 'Tentar de novo',
    service_unavailable: 'Estamos a fazer uns ajustes e isto não está disponível agora. Volta daqui a pouco ou escreve-nos 🤍',
    network_error: 'Ups, não conseguimos ligar. Tentamos de novo?',
    invalid_email_server: 'Esse email não parece válido. Verificamos? 🤍',
  },
};

const C_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Topic taxonomy: { key, labelKey, behaviour, ... }.
// behaviour: 'deflect' | 'form'. For 'form', `casuistica` is the backend code.
const TOPICS = {
  order: [
    { key: 'where',   labelKey: 'a_where',   behaviour: 'deflect', deflect: 'where' },
    { key: 'return',  labelKey: 'a_return',  behaviour: 'deflect', deflect: 'return' },
    { key: 'address', labelKey: 'a_address', behaviour: 'form', casuistica: 'direccion', kind: 'address' },
    { key: 'missing', labelKey: 'a_missing', behaviour: 'form', casuistica: 'falta_incorrecto', kind: 'escalate', needOrder: true },
    { key: 'refund',  labelKey: 'a_refund',  behaviour: 'form', casuistica: 'reembolso', kind: 'escalate', needOrder: true },
  ],
  other: [
    { key: 'product',  labelKey: 'b_product',  behaviour: 'form', casuistica: 'producto', kind: 'product' },
    { key: 'discount', labelKey: 'b_discount', behaviour: 'form', casuistica: 'descuento', kind: 'discount' },
    { key: 'payment',  labelKey: 'b_payment',  behaviour: 'form', casuistica: 'pago', kind: 'escalate' },
    { key: 'account',  labelKey: 'b_account',  behaviour: 'form', casuistica: 'cuenta', kind: 'escalate' },
    { key: 'policy',   labelKey: 'b_policy',   behaviour: 'deflect', deflect: 'policy' },
    { key: 'collab',   labelKey: 'b_collab',   behaviour: 'deflect', deflect: 'collab' },
    { key: 'other',    labelKey: 'b_other',    behaviour: 'form', casuistica: 'otra', kind: 'escalate' },
  ],
};

class ContactOnne extends HTMLElement {
  connectedCallback() {
    // Prefer the visitor's BROWSER language — the storefront is EN-only so data-lang
    // is always 'en'. Falls back to data-lang, then 'es'.
    const _supp = ['es', 'en', 'it', 'pt'];
    const _pick = (v) => { v = (v || '').slice(0, 2).toLowerCase(); return _supp.indexOf(v) >= 0 ? v : ''; };
    const lang = _pick(navigator.language) || _pick(this.dataset.lang) || 'es';
    this.t = CCOPY[lang] || CCOPY.es;
    this.lang = CCOPY[lang] ? lang : 'es';
    this.endpoint = (this.dataset.endpoint || '').replace(/\/+$/, '');
    this.contact = this.dataset.contact || 'mailto:info@onne.com';
    this.conditionsUrl = this.dataset.conditions || '/pages/conditions';
    this.statusUrl = this.dataset.statusUrl || '/pages/estado-pedido';
    this.returnsUrl = this.dataset.returnsUrl || '/pages/devoluciones';
    this.root = this.querySelector('[data-contact-root]') || this;
    this.branch = null;
    this.topic = null;
    this.renderQ1();
  }

  // -------------------------------------------------------------- helpers
  _set(html) { this.root.innerHTML = html; }
  _api(path) { return `${this.endpoint}${path}`; }
  _talk() { return `<a class="support-onne__link support-onne__link--center" href="${this.contact}">${this.t.talk_team}</a>`; }
  _fmt(str, map) { return Object.keys(map || {}).reduce((s, k) => s.split('{' + k + '}').join(map[k]), str); }

  _detectFactor(raw) {
    const v = (raw || '').trim();
    if (v.includes('@')) return { email: v };
    const d = v.replace(/\D/g, '');
    if (d.length >= 4) return { phone_last4: d.slice(-4) };
    return null;
  }

  _topicLabel(topic) { return this.t[topic.labelKey] || topic.key; }

  // -------------------------------------------------------------- Q1: ¿es sobre un pedido?
  renderQ1() {
    const t = this.t;
    this.branch = null; this.topic = null;
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <p class="support-onne__subtitle">${t.subtitle}</p>
      <div class="support-onne__card support-onne__card--narrow contact-onne__choices">
        <p class="contact-onne__q">${t.q1_title}</p>
        <button class="support-onne__btn contact-onne__choice" type="button" data-branch="order">${t.q1_yes}</button>
        <button class="support-onne__btn contact-onne__choice contact-onne__choice--alt" type="button" data-branch="other">${t.q1_no}</button>
      </div>
    `);
    this.root.querySelectorAll('[data-branch]').forEach((b) => {
      b.addEventListener('click', () => { this.branch = b.getAttribute('data-branch'); this.renderQ2(); });
    });
  }

  // -------------------------------------------------------------- Q2: select de casuísticas
  renderQ2() {
    const t = this.t;
    const list = TOPICS[this.branch] || [];
    const titleKey = this.branch === 'order' ? 'branch_order_title' : 'branch_other_title';
    const opts = list.map((tp, i) => `<option value="${i}">${this._topicLabel(tp)}</option>`).join('');
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <div class="support-onne__card support-onne__card--narrow">
        <p class="returns-onne__items-title">${t[titleKey]}</p>
        <div class="support-onne__field">
          <label class="support-onne__label" for="c-topic">${t.select_ph}</label>
          <select class="support-onne__input" id="c-topic" data-topic>
            <option value="" selected disabled>${t.select_ph}</option>
            ${opts}
          </select>
          <p class="support-onne__error" data-err-topic hidden></p>
        </div>
        <button class="support-onne__btn" type="button" data-continue>${t.cta_continue}</button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    this.root.querySelector('[data-continue]').addEventListener('click', () => {
      const sel = this.root.querySelector('[data-topic]');
      const idx = sel.value;
      if (idx === '' || idx == null) {
        const e = this.root.querySelector('[data-err-topic]'); e.textContent = t.select_ph; e.hidden = false; return;
      }
      this.topic = list[parseInt(idx, 10)];
      this._routeTopic();
    });
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderQ1());
  }

  _routeTopic() {
    const tp = this.topic;
    if (tp.behaviour === 'deflect') return this.renderDeflection(tp.deflect);
    if (tp.kind === 'address') return this.renderAddressForm();
    if (tp.kind === 'discount') return this.renderDiscountForm();
    if (tp.kind === 'product') return this.renderProductForm();
    return this.renderEscalateForm();
  }

  // -------------------------------------------------------------- Deflections (no backend)
  renderDeflection(which) {
    const t = this.t;
    let body = '';
    if (which === 'where') {
      body = `<p class="returns-onne__items-title">${t.defl_where_title}</p>
        <p class="support-onne__state-msg">${t.defl_where_body}</p>
        <a class="support-onne__btn" href="${this.statusUrl}">${t.defl_where_cta}</a>`;
    } else if (which === 'return') {
      body = `<p class="returns-onne__items-title">${t.defl_return_title}</p>
        <p class="support-onne__state-msg">${t.defl_return_body}</p>
        <a class="support-onne__btn" href="${this.returnsUrl}">${t.defl_return_cta}</a>`;
    } else if (which === 'collab') {
      // mailto:info@onne.com — no backend.
      body = `<p class="support-onne__state-msg">${this._topicLabel(this.topic)}</p>
        <a class="support-onne__btn" href="mailto:info@onne.com">info@onne.com</a>`;
    } else if (which === 'policy') {
      // Visual sectioned policy (Hawkers-style), inline on the page — our official
      // copy. policy[i] is paired with its heading policy_titles[i].
      const titles = t.policy_titles || [];
      const sections = t.policy.map((p, i) => `<div class="contact-onne__polsec">
          <p class="contact-onne__polsec-title">${titles[i] || ''}</p>
          <p class="contact-onne__polsec-body">${p}</p>
        </div>`).join('');
      body = `<p class="returns-onne__items-title">${t.defl_policy_title}</p>
        <div class="contact-onne__policy">${sections}</div>
        <a class="support-onne__btn" href="${this.conditionsUrl}" style="margin-top:1rem">${t.defl_policy_cta}</a>`;
    }
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <div class="support-onne__card support-onne__card--narrow support-onne__state">
        ${body}
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderQ2());
  }

  // -------------------------------------------------------------- Shared field builders
  _nameField() {
    const t = this.t;
    return `<div class="support-onne__field" data-field-name>
      <label class="support-onne__label" for="c-name">${t.f_name}</label>
      <input class="support-onne__input" id="c-name" type="text" autocomplete="name" placeholder="${t.f_name_ph}">
      <p class="support-onne__error" data-err-name hidden></p>
    </div>`;
  }
  _emailField() {
    const t = this.t;
    return `<div class="support-onne__field" data-field-email>
      <label class="support-onne__label" for="c-email">${t.f_email}</label>
      <input class="support-onne__input" id="c-email" type="email" autocomplete="email" placeholder="${t.f_email_ph}">
      <p class="support-onne__error" data-err-email hidden></p>
    </div>`;
  }
  _messageField() {
    const t = this.t;
    return `<div class="support-onne__field" data-field-message>
      <label class="support-onne__label" for="c-message">${t.f_message}</label>
      <textarea class="support-onne__input" id="c-message" rows="4" placeholder="${t.f_message_ph}" style="resize:vertical"></textarea>
      <p class="support-onne__error" data-err-message hidden></p>
    </div>`;
  }
  _orderField() {
    const t = this.t;
    return `<div class="support-onne__field" data-field-order>
      <label class="support-onne__label" for="c-order">${t.f_order}</label>
      <input class="support-onne__input" id="c-order" type="text" autocomplete="off" placeholder="${t.f_order_ph}">
      <p class="support-onne__error" data-err-order hidden></p>
    </div>`;
  }
  _factorField() {
    const t = this.t;
    return `<div class="support-onne__field" data-field-factor>
      <label class="support-onne__label" for="c-factor">${t.f_factor}</label>
      <input class="support-onne__input" id="c-factor" type="text" autocomplete="off" placeholder="${t.f_factor_ph}">
      <p class="support-onne__help">${t.f_factor_help}</p>
      <p class="support-onne__error" data-err-factor hidden></p>
    </div>`;
  }
  _consentField() {
    const t = this.t;
    const label = this._fmt(t.consent, { url: this.conditionsUrl });
    return `<label class="returns-onne__check" data-field-consent>
      <input type="checkbox" data-consent>
      <span>${label}</span>
    </label>
    <p class="support-onne__error" data-err-consent hidden></p>`;
  }
  // Honeypot: visually hidden, off-screen, not announced. Bots fill it → server discards.
  _honeypot() {
    return `<div aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden">
      <label>Do not fill this field<input type="text" tabindex="-1" autocomplete="off" data-hp></label>
    </div>`;
  }

  _fieldErr(which, msg) {
    const field = this.root.querySelector(`[data-field-${which}]`);
    if (field) field.classList.add('support-onne__field--error');
    const e = this.root.querySelector(`[data-err-${which}]`);
    if (e) { e.textContent = msg; e.hidden = false; }
  }
  _clearErrs() {
    this.root.querySelectorAll('.support-onne__field--error').forEach((f) => f.classList.remove('support-onne__field--error'));
    this.root.querySelectorAll('.support-onne__error').forEach((e) => { e.hidden = true; });
  }
  _val(id) { const el = this.root.querySelector('#' + id); return el ? el.value.trim() : ''; }
  _hp() { const el = this.root.querySelector('[data-hp]'); return el ? el.value : ''; }
  _consentChecked() { const el = this.root.querySelector('[data-consent]'); return !!(el && el.checked); }

  _cardShell(inner, submitLabel, submitAttr) {
    const t = this.t;
    return `
      <h1 class="support-onne__title">${t.title}</h1>
      <form class="support-onne__card support-onne__card--narrow" data-form novalidate>
        <p class="returns-onne__items-title">${this._topicLabel(this.topic)}</p>
        ${inner}
        ${this._consentField()}
        ${this._honeypot()}
        <button class="support-onne__btn" type="submit" ${submitAttr || ''}>${submitLabel}</button>
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </form>
    `;
  }

  // -------------------------------------------------------------- Escalate form (name+email+message)
  renderEscalateForm() {
    const t = this.t;
    const orderField = this.topic.needOrder ? this._orderField() : '';
    this._set(this._cardShell(
      this._nameField() + this._emailField() + orderField + this._messageField(),
      t.cta_send,
    ));
    this._wireForm(() => this._submitEscalate());
  }

  // -------------------------------------------------------------- Product info form (auto-resuelve)
  renderProductForm() {
    const t = this.t;
    const inner = `<div class="support-onne__field" data-field-product_query>
        <label class="support-onne__label" for="c-product_query">${t.f_product_query}</label>
        <input class="support-onne__input" id="c-product_query" type="text" autocomplete="off" placeholder="${t.f_product_query_ph}">
        <p class="support-onne__error" data-err-product_query hidden></p>
      </div>` + this._nameField() + this._emailField();
    this._set(this._cardShell(inner, t.cta_check_product));
    this._wireForm(() => this._submitProduct());
  }

  // -------------------------------------------------------------- Discount form (auto-resuelve)
  renderDiscountForm() {
    const t = this.t;
    const inner = `<div class="support-onne__field" data-field-discount_code>
        <label class="support-onne__label" for="c-discount_code">${t.f_discount_code}</label>
        <input class="support-onne__input" id="c-discount_code" type="text" autocomplete="off" placeholder="${t.f_discount_code_ph}">
        <p class="support-onne__error" data-err-discount_code hidden></p>
      </div>` + this._emailField();
    this._set(this._cardShell(inner, t.cta_check_discount));
    this._wireForm(() => this._submitDiscount());
  }

  // -------------------------------------------------------------- Address change form (acción gated + D-11)
  renderAddressForm() {
    const t = this.t;
    const inner = `
      <p class="support-onne__help" style="margin-top:0">${t.addr_intro}</p>
      ${this._orderField()}
      ${this._factorField()}
      <p class="returns-onne__items-title" style="margin-top:1.25rem">${t.addr_title}</p>
      <div class="support-onne__field" data-field-first_name>
        <label class="support-onne__label" for="c-first_name">${t.a_first_name}</label>
        <input class="support-onne__input" id="c-first_name" type="text" autocomplete="off" placeholder="${t.f_name_ph}">
      </div>
      <div class="support-onne__field" data-field-last_name>
        <label class="support-onne__label" for="c-last_name">${t.a_last_name}</label>
        <input class="support-onne__input" id="c-last_name" type="text" autocomplete="off">
      </div>
      <div class="support-onne__field" data-field-address1>
        <label class="support-onne__label" for="c-address1">${t.a_address1}</label>
        <input class="support-onne__input" id="c-address1" type="text" autocomplete="off" placeholder="${t.a_address1_ph}">
        <p class="support-onne__error" data-err-address1 hidden></p>
      </div>
      <div class="support-onne__field" data-field-address2>
        <label class="support-onne__label" for="c-address2">${t.a_address2}</label>
        <input class="support-onne__input" id="c-address2" type="text" autocomplete="off" placeholder="${t.a_address2_ph}">
      </div>
      <div class="support-onne__field" data-field-city>
        <label class="support-onne__label" for="c-city">${t.a_city}</label>
        <input class="support-onne__input" id="c-city" type="text" autocomplete="off" placeholder="${t.a_city_ph}">
        <p class="support-onne__error" data-err-city hidden></p>
      </div>
      <div class="support-onne__field" data-field-zip>
        <label class="support-onne__label" for="c-zip">${t.a_zip}</label>
        <input class="support-onne__input" id="c-zip" type="text" autocomplete="off" placeholder="${t.a_zip_ph}">
        <p class="support-onne__error" data-err-zip hidden></p>
      </div>
      <div class="support-onne__field" data-field-province>
        <label class="support-onne__label" for="c-province">${t.a_province}</label>
        <input class="support-onne__input" id="c-province" type="text" autocomplete="off" placeholder="${t.a_province_ph}">
      </div>
      <div class="support-onne__field" data-field-country>
        <label class="support-onne__label" for="c-country">${t.a_country}</label>
        <input class="support-onne__input" id="c-country" type="text" autocomplete="off" placeholder="${t.a_country_ph}">
        <p class="support-onne__error" data-err-country hidden></p>
      </div>
      <div class="support-onne__field" data-field-phone>
        <label class="support-onne__label" for="c-phone">${t.a_phone}</label>
        <input class="support-onne__input" id="c-phone" type="tel" autocomplete="off" placeholder="${t.a_phone_ph}">
      </div>`;
    this._set(this._cardShell(inner, t.cta_send_address));
    this._wireForm(() => this._submitAddress());
  }

  _wireForm(onSubmit) {
    const form = this.root.querySelector('[data-form]');
    form.addEventListener('submit', (e) => { e.preventDefault(); onSubmit(); });
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderQ2());
  }

  renderLoading() {
    this._set(`<div class="support-onne__loading" role="status" aria-live="polite">${this.t.loading}</div>`);
  }

  // -------------------------------------------------------------- Validation helpers
  _checkName() {
    const v = this._val('c-name');
    if (!v) { this._fieldErr('name', this.t.need_name); return null; }
    return v;
  }
  _checkEmail() {
    const v = this._val('c-email');
    if (!v || !C_EMAIL_RE.test(v)) { this._fieldErr('email', this.t.need_email); return null; }
    return v;
  }
  _checkConsent() {
    if (!this._consentChecked()) {
      this._fieldErr('consent', this.t.need_consent);
      return false;
    }
    return true;
  }

  // -------------------------------------------------------------- Submitters
  async _post(payload) {
    if (!this.endpoint) { this.renderUnavailable(); return null; }
    let resp, data;
    try {
      resp = await fetch(this._api('/api/support/contact'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (e) { return { _network: true }; }
    if (resp.status === 503) return { _unavailable: true };
    try { data = await resp.json(); } catch (e) { return { _network: true }; }
    data._status = resp.status;
    return data;
  }

  _basePayload(extra) {
    return Object.assign({
      casuistica: this.topic.casuistica,
      lang: this.lang,
      hp: this._hp(),
    }, extra || {});
  }

  async _submitEscalate() {
    this._clearErrs();
    const name = this._checkName();
    const email = this._checkEmail();
    const message = this._val('c-message');
    let bad = (!name || !email);
    if (!message) { this._fieldErr('message', this.t.need_message); bad = true; }
    let order_number;
    if (this.topic.needOrder) {
      order_number = this._val('c-order');
      if (!order_number) { this._fieldErr('order', this.t.need_order); bad = true; }
    }
    if (!this._checkConsent()) bad = true;
    if (bad) return;
    this.renderLoading();
    const data = await this._post(this._basePayload({ name, email, message, order_number }));
    this._handle(data, () => this.renderEscalateForm());
  }

  async _submitProduct() {
    this._clearErrs();
    const product_query = this._val('c-product_query');
    const name = this._checkName();
    const email = this._checkEmail();
    let bad = (!name || !email);
    if (!product_query) { this._fieldErr('product_query', this.t.need_product_query); bad = true; }
    if (!this._checkConsent()) bad = true;
    if (bad) return;
    this.renderLoading();
    const data = await this._post(this._basePayload({ name, email, product_query }));
    this._handle(data, () => this.renderProductForm());
  }

  async _submitDiscount() {
    this._clearErrs();
    const discount_code = this._val('c-discount_code');
    const email = this._checkEmail();
    let bad = !email;
    if (!discount_code) { this._fieldErr('discount_code', this.t.need_discount_code); bad = true; }
    if (!this._checkConsent()) bad = true;
    if (bad) return;
    this.renderLoading();
    const data = await this._post(this._basePayload({ email, discount_code }));
    this._handle(data, () => this.renderDiscountForm());
  }

  async _submitAddress() {
    this._clearErrs();
    const order_number = this._val('c-order');
    const factor = this._detectFactor(this._val('c-factor'));
    const address1 = this._val('c-address1');
    const city = this._val('c-city');
    const zip = this._val('c-zip');
    const country = this._val('c-country');
    let bad = false;
    if (!order_number) { this._fieldErr('order', this.t.need_order); bad = true; }
    if (!factor) { this._fieldErr('factor', this.t.need_factor); bad = true; }
    if (!address1) { this._fieldErr('address1', this.t.need_address); bad = true; }
    if (!city) { this._fieldErr('city', this.t.need_address); bad = true; }
    if (!zip) { this._fieldErr('zip', this.t.need_address); bad = true; }
    if (!country) { this._fieldErr('country', this.t.need_address); bad = true; }
    if (!this._checkConsent()) bad = true;
    if (bad) return;
    const new_address = {
      address1,
      address2: this._val('c-address2') || undefined,
      city,
      zip,
      province_code: this._val('c-province') || undefined,
      country_code: country,
      first_name: this._val('c-first_name') || undefined,
      last_name: this._val('c-last_name') || undefined,
      phone: this._val('c-phone') || undefined,
    };
    this.renderLoading();
    const data = await this._post(this._basePayload({
      order_number,
      second_factor: factor,
      new_address,
    }));
    this._handle(data, () => this.renderAddressForm());
  }

  // -------------------------------------------------------------- Response router
  _handle(data, retryFn) {
    if (!data) return; // _post already rendered unavailable (no endpoint)
    if (data._network) return this.renderNetworkError(retryFn);
    if (data._unavailable || data.disabled) return this.renderUnavailable();
    if (data._status === 400 || data.error === 'invalid_email') {
      // Re-show the form with a server-side hint.
      retryFn();
      this._clearErrs();
      this._fieldErr('email', this.t.invalid_email_server);
      return;
    }

    // 🟢 Auto-resolved: discount
    if (data.resolved && data.kind === 'discount') return this.renderDiscountResult(data.data || {});
    // 🟢 Auto-resolved: product
    if (data.resolved && data.kind === 'product') return this.renderProductResult(data.data || {});
    // 🟢 Disambiguation: a few candidates to pick from
    if (!data.resolved && data.kind === 'product_candidates') {
      return this.renderProductCandidates(data.candidates || []);
    }

    // 🔵 Address actions
    if (data.action === 'address_updated') {
      const order = data.order_name || data.order_number || '';
      return this.renderState(this._fmt(this.t.address_updated, { order }), true);
    }
    if (data.action === 'verification_required') {
      return this.renderState(this.t.verification_required, false, retryFn);
    }
    if (data.action === 'verification_failed') {
      const attempts = (data.attempts_left != null)
        ? this._fmt(this.t.verification_attempts, { n: data.attempts_left })
        : '';
      const msg = this._fmt(this.t.verification_failed, { attempts }).trim();
      // Still some attempts left → let them retry the form; else escalate to team.
      if (data.attempts_left && data.attempts_left > 0) {
        return this.renderState(msg, true, retryFn);
      }
      return this.renderState(msg, true);
    }
    if (data.action && data.action.indexOf('address_escalated') === 0) {
      return this.renderState(this.t.address_escalated, true);
    }

    // 🟠 Escalations (ticket created)
    if (data.escalated) {
      const ref = data.ticket_ref || data.escalated_to;
      const extra = ref ? `\n${this._fmt(this.t.escalated_ref, { ref })}` : '';
      return this.renderState(this.t.escalated + extra, true);
    }

    // Fallback: unknown shape → graceful escalate copy.
    return this.renderState(this.t.escalated, true);
  }

  // -------------------------------------------------------------- Result renderers (structured)
  renderDiscountResult(d) {
    const t = this.t;
    const found = d.found || d.status === 'active' || d.status === 'valid';
    let msg;
    if (found) {
      const code = d.code || '';
      msg = this._fmt(t.discount_valid, { code });
      if (d.percentage != null) msg += ' ' + this._fmt(t.discount_value_pct, { value: d.percentage });
      else if (d.amount != null) msg += ' ' + this._fmt(t.discount_value_amount, { value: d.amount });
    } else {
      msg = t.discount_invalid;
    }
    this.renderState(msg, true);
  }

  _money(amount, currency) {
    const n = Number(amount);
    const val = (isFinite(n) ? n : 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const sym = currency === 'EUR' || !currency ? '€' : currency;
    return `${val} ${sym}`.trim();
  }

  // Interactive visual product card: real photo that swaps per colour, sizes with
  // live availability per colour, price + link to the PDP. All catalog strings are
  // set via textContent / src (never innerHTML) — no injection.
  renderProductResult(d) {
    const t = this.t;
    if (!d || (!d.title && !(d.colors && d.colors.length) && !(d.variants && d.variants.length))) {
      return this.renderState(t.product_not_found, true);
    }
    const colors = Array.isArray(d.colors) ? d.colors : [];
    const sizes = Array.isArray(d.sizes) ? d.sizes : [];
    const matrix = d.matrix || {};
    const fallbackImg = (d.image && d.image.url) || '';
    const material = d.material || (d.metafields && (d.metafields.material || d.metafields.fabric)) || '';

    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <div class="support-onne__card support-onne__card--narrow contact-onne__pwrap" data-product></div>
    `);
    const root = this.root.querySelector('[data-product]');

    const card = document.createElement('div');
    card.className = 'contact-onne__pcard';

    const figure = document.createElement('div');
    figure.className = 'contact-onne__pphoto';
    const img = document.createElement('img');
    img.className = 'contact-onne__pimg';
    img.loading = 'eager';
    img.alt = d.title || '';
    figure.appendChild(img);

    const info = document.createElement('div');
    info.className = 'contact-onne__pinfo';

    const name = document.createElement('p');
    name.className = 'contact-onne__pname';
    name.textContent = d.title || '';
    info.appendChild(name);

    if (d.price && d.price.amount != null) {
      const price = document.createElement('p');
      price.className = 'contact-onne__pprice';
      price.textContent = (d.price.from ? t.product_price_from + ' ' : '') + this._money(d.price.amount, d.price.currency);
      info.appendChild(price);
    }

    let colorNameEl = null;
    let swatchesEl = null;
    if (colors.length) {
      const cl = document.createElement('p');
      cl.className = 'contact-onne__plabel';
      const tag = document.createElement('span');
      tag.textContent = t.product_color + ' · ';
      colorNameEl = document.createElement('span');
      colorNameEl.className = 'contact-onne__pcolorname';
      cl.appendChild(tag);
      cl.appendChild(colorNameEl);
      info.appendChild(cl);

      swatchesEl = document.createElement('div');
      swatchesEl.className = 'contact-onne__pswatches';
      colors.forEach((c, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'contact-onne__pswatch';
        b.setAttribute('aria-label', c.name || '');
        if (c.image) {
          const si = document.createElement('img');
          si.src = c.image; si.alt = c.name || ''; si.loading = 'lazy';
          b.appendChild(si);
        } else {
          b.textContent = (c.name || '?').slice(0, 2);
        }
        b.addEventListener('click', () => selectColor(i));
        swatchesEl.appendChild(b);
      });
      info.appendChild(swatchesEl);
    }

    const sizeLabel = document.createElement('p');
    sizeLabel.className = 'contact-onne__plabel';
    sizeLabel.textContent = t.product_size;
    info.appendChild(sizeLabel);
    const sizesWrap = document.createElement('div');
    sizesWrap.className = 'contact-onne__psizes';
    info.appendChild(sizesWrap);

    if (material) {
      const m = document.createElement('p');
      m.className = 'contact-onne__pmaterial';
      const ms = document.createElement('strong');
      ms.textContent = t.product_material + ': ';
      const mv = document.createElement('span');
      mv.textContent = material;
      m.appendChild(ms);
      m.appendChild(mv);
      info.appendChild(m);
    }

    if (d.url && /^https?:\/\//i.test(d.url)) {
      const a = document.createElement('a');
      a.className = 'contact-onne__pcta';
      a.href = d.url; a.target = '_blank'; a.rel = 'noopener';
      a.textContent = t.product_view;
      info.appendChild(a);
    }

    const hint = document.createElement('p');
    hint.className = 'contact-onne__phint';
    hint.textContent = t.product_not_this;
    info.appendChild(hint);

    card.appendChild(figure);
    card.appendChild(info);
    root.appendChild(card);

    const foot = document.createElement('div');
    foot.className = 'contact-onne__pfoot';
    foot.innerHTML = this._talk()
      + `<button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>`;
    root.appendChild(foot);
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderProductForm());

    const renderSizes = (colorName) => {
      sizesWrap.innerHTML = '';
      let entries = [];
      if (colorName && matrix[colorName]) {
        const order = sizes.length ? sizes : Object.keys(matrix[colorName]);
        entries = order.filter((s) => s in matrix[colorName]).map((s) => [s, matrix[colorName][s]]);
      } else if (sizes.length) {
        entries = sizes.map((s) => [s, true]);
      }
      if (!entries.length) {
        const none = document.createElement('span');
        none.className = 'contact-onne__pnostock';
        none.textContent = t.product_unavailable;
        sizesWrap.appendChild(none);
        return;
      }
      entries.forEach(([s, ok]) => {
        const chip = document.createElement('span');
        chip.className = 'contact-onne__psize' + (ok ? '' : ' contact-onne__psize--out');
        chip.textContent = s;
        if (!ok) chip.title = t.product_sold_out;
        sizesWrap.appendChild(chip);
      });
    };

    const selectColor = (i) => {
      const c = colors[i];
      if (!c) return;
      const src = c.image || fallbackImg;
      if (src) { img.src = src; figure.style.display = ''; } else { figure.style.display = 'none'; }
      img.alt = (d.title || '') + ' — ' + (c.name || '');
      if (colorNameEl) colorNameEl.textContent = c.name || '';
      if (swatchesEl) {
        Array.from(swatchesEl.children).forEach((el, idx) => el.classList.toggle('is-selected', idx === i));
      }
      renderSizes(c.name);
    };

    if (colors.length) {
      const firstAvail = colors.findIndex((c) => c.available);
      selectColor(firstAvail >= 0 ? firstAvail : 0);
    } else {
      if (fallbackImg) { img.src = fallbackImg; } else { figure.style.display = 'none'; }
      renderSizes(null);
    }
  }

  // Disambiguation gallery: a few candidate cards (photo + name + price). Picking
  // one re-POSTs with its handle → full product card.
  renderProductCandidates(candidates) {
    const t = this.t;
    const list = (candidates || []).filter((c) => c && c.handle);
    if (!list.length) return this.renderState(t.product_not_found, true);
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <div class="support-onne__card support-onne__card--narrow">
        <p class="returns-onne__items-title">${t.product_choose}</p>
        <div class="contact-onne__pgallery" data-gallery></div>
        ${this._talk()}
        <button class="support-onne__link support-onne__link--center" type="button" data-back>${t.back}</button>
      </div>
    `);
    const gal = this.root.querySelector('[data-gallery]');
    list.forEach((c) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'contact-onne__gitem';
      if (c.image && c.image.url) {
        const im = document.createElement('img');
        im.className = 'contact-onne__gimg';
        im.src = c.image.url; im.alt = c.title || ''; im.loading = 'lazy';
        btn.appendChild(im);
      }
      const meta = document.createElement('span');
      meta.className = 'contact-onne__gmeta';
      const nm = document.createElement('span');
      nm.className = 'contact-onne__gname';
      nm.textContent = c.title || '';
      meta.appendChild(nm);
      if (c.price && c.price.amount != null) {
        const pr = document.createElement('span');
        pr.className = 'contact-onne__gprice';
        pr.textContent = this._money(c.price.amount, c.price.currency);
        meta.appendChild(pr);
      }
      btn.appendChild(meta);
      btn.addEventListener('click', () => this._submitProductHandle(c.handle));
      gal.appendChild(btn);
    });
    this.root.querySelector('[data-back]').addEventListener('click', () => this.renderProductForm());
  }

  async _submitProductHandle(handle) {
    if (!handle) return;
    this.renderLoading();
    const data = await this._post(this._basePayload({ product_handle: handle }));
    this._handle(data, () => this.renderProductForm());
  }

  // -------------------------------------------------------------- generic states
  renderState(msg, withTeam, retryFn) {
    const t = this.t;
    const retryBtn = retryFn ? `<button class="support-onne__btn" type="button" data-retry>${t.retry}</button>` : '';
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <div class="support-onne__state support-onne__card support-onne__card--narrow">
        <p class="support-onne__state-msg js-msg"></p>
        ${retryBtn}
        ${withTeam ? this._talk() : ''}
      </div>
    `);
    this.root.querySelector('.js-msg').textContent = msg;
    if (retryFn) this.root.querySelector('[data-retry]').addEventListener('click', retryFn);
  }

  renderUnavailable() { this.renderState(this.t.service_unavailable, true); }

  renderNetworkError(retryFn) {
    const t = this.t;
    this._set(`
      <h1 class="support-onne__title">${t.title}</h1>
      <div class="support-onne__state support-onne__card support-onne__card--narrow">
        <p class="support-onne__state-msg">${t.network_error}</p>
        <button class="support-onne__btn" type="button" data-retry>${t.retry}</button>
      </div>
    `);
    this.root.querySelector('[data-retry]').addEventListener('click', retryFn);
  }
}

if (!customElements.get('contact-onne')) {
  customElements.define('contact-onne', ContactOnne);
}
